function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.876 8l.458.2a.5.5 0 000-.4l-.458.2zM1.124 8l-.458-.2a.5.5 0 000 .4l.458-.2zM8 13c3.281 0 6.1-1.975 7.334-4.8l-.916-.4A7.002 7.002 0 018 12v1zM.666 8.2A8.002 8.002 0 008 13v-1a7.002 7.002 0 01-6.418-4.2l-.916.4zM8 3A8.002 8.002 0 00.666 7.8l.916.4A7.002 7.002 0 018 4V3zm7.334 4.8A8.002 8.002 0 008 3v1a7.002 7.002 0 016.418 4.2l.916-.4z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8 10a2 2 0 100-4 2 2 0 000 4z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgEye;